import * as React from 'react';
import { cn } from '../../lib/utils';
import { Button, type ButtonProps } from './button';

export interface IconButtonProps extends Omit<ButtonProps, 'children'> {
  /** Required accessible label — icon-only buttons must announce intent. */
  'aria-label': string;
  icon: React.ReactNode;
  /** Tooltip-friendly title (defaults to aria-label). */
  title?: string;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, className, size = 'icon', variant = 'ghost', title, ...props }, ref) => (
    <Button
      ref={ref}
      size={size}
      variant={variant}
      title={title ?? props['aria-label']}
      className={cn('shrink-0', className)}
      {...props}
    >
      {icon}
    </Button>
  ),
);
IconButton.displayName = 'IconButton';

export { IconButton };
